const euroFormatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' })

export function formatEuro(value: number | null | undefined): string {
  return euroFormatter.format(value ?? 0)
}

/** Backend sends `TimeOnly` as `HH:mm:ss`, the table only shows `HH:mm`. */
export function formatTime(value: string | null | undefined): string {
  return value ? value.slice(0, 5) : ''
}

/** Time column of an entry: full day label or `08:00 – 17:30`. */
export function formatTimeRange(
  entry: { startTime?: string | null; endTime?: string | null },
  fullDayLabel: string,
): string {
  if (!entry.startTime || !entry.endTime) return '—'
  const start = formatTime(entry.startTime)
  const end = formatTime(entry.endTime)
  // Backend has no full day flag, 00:00–23:59 is a full day (sheet: 0:00–24:00)
  if (start === '00:00' && end === '23:59') return fullDayLabel
  return `${start} – ${end}`
}

/** Werbungskosten: office supplies + phone + other */
export function businessCost(x: { officeSupplies: number; phoneCost: number; otherBusinessCost: number }): number {
  return x.officeSupplies + x.phoneCost + x.otherBusinessCost
}

/** Autokosten: fuel + parking + repair + other */
export function carCost(x: { fuelCost: number; parkingCost: number; repairCost: number; otherCarCost: number }): number {
  return x.fuelCost + x.parkingCost + x.repairCost + x.otherCarCost
}

/** Odometer column: `1.000 – 1.250`, a missing side as `—` */
export function formatOdometer(start: number | null | undefined, end: number | null | undefined): string {
  if (start == null && end == null) return '—'
  const fmt = (v: number | null | undefined) => (v == null ? '—' : v.toLocaleString('de-DE'))
  return `${fmt(start)} – ${fmt(end)}`
}

/** `YYYY-MM` from the month input into the year/month query of the summaries endpoint. */
export function parseMonth(value: string): { year: number; month: number } | undefined {
  const match = /^(\d{4})-(\d{2})$/.exec(value)
  if (!match) return undefined
  const year = Number(match[1])
  const month = Number(match[2])
  if (month < 1 || month > 12) return undefined
  return { year, month }
}

/** First and last day (ISO date) of a `YYYY-MM` month, for the entry list filter. */
export function monthToDateRange(value: string): { from?: string; to?: string } {
  const parsed = parseMonth(value)
  if (!parsed) return {}
  const lastDay = new Date(Date.UTC(parsed.year, parsed.month, 0)).getUTCDate()
  const mm = String(parsed.month).padStart(2, '0')
  return { from: `${parsed.year}-${mm}-01`, to: `${parsed.year}-${mm}-${String(lastDay).padStart(2, '0')}` }
}
